import React from 'react';
import {
    Failed,
    SetupInstructions,
    SignIn,
    Success
} from '$ui/Integrations/Screens';
import OutlookLogo from '$resources/outlook.svg';
import { Frame } from '$ui/Integrations/Frame';
import { SyncState } from '$types/integrations';
import {
    setup,
    SetupContext,
    useWorkflow
} from '$ui/Integrations/Workflows/workflows';
import { outlook as instructions } from '$ui/Integrations/instructions';

interface Props {
    auth: () => Promise<void>;
    sync: () => void;
    syncState: SyncState;
    onFinish: () => void;
}

// TODO: Refactor this when introducing a new integration
export const OutlookSetup = ({ auth, sync, onFinish, syncState }: Props) => {
    const { matches, onSync, onSignIn, onNext, onBack, context } =
        useWorkflow<SetupContext>({
            healthyState: 'success',
            workflow: setup,
            syncState,
            auth,
            sync
        });

    const next = !['signIn', 'failed'].some(matches);
    const back = !matches('instructions');
    const last = matches('success');

    return (
        <Frame
            integration="Outlook"
            mode="Set up"
            next={next}
            back={back}
            last={last}
            onExit={onFinish}
            onNext={onNext}
            onFinish={onFinish}
            onBack={onBack}
        >
            {matches('instructions') && (
                <SetupInstructions
                    instructions={instructions}
                    integration="Outlook"
                    vimeoEmbedUrl="https://player.vimeo.com/video/768966265?h=7ffaee058b&badge=0&autopause=0&player_id=0&app_id=58479"
                />
            )}

            {matches('signIn') && (
                <SignIn
                    logo={OutlookLogo}
                    integration="Outlook"
                    onSignIn={onSignIn}
                    signingIn={matches('signIn.signingIn')}
                />
            )}

            {matches('success') && (
                <Success
                    integration="Outlook"
                    onSync={onSync}
                    syncing={matches('success.syncing')}
                />
            )}

            {matches('failed') && (
                <Failed
                    integration="Outlook"
                    mode={context.failureMode}
                    onSignIn={onSignIn}
                    signingIn={matches('failed.signingIn')}
                />
            )}
        </Frame>
    );
};
